<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TRQDZ3/tc-custom/9780374710033.jpg?1736425677119" alt="This image is the cover for the book Greek House"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Greek House
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A richly rewarding narrative about a young painter's love affair with the Greek island of Sifnos</b><br/><br/>When Christian Brechneff first set foot on the Greek island of Sifnos, it was the spring of 1972 and he was a twenty-one-year-old painter searching for artistic inspiration and a quiet place to work. There, this Swiss child of Russian émigrés, adrift and confused about his sexuality, found something extraordinary. In Sifnos, he found a muse, a subject he was to paint for years, and a sanctuary.<br/> In <i>The Greek House</i>, Brechneff tells a funny, touching narrative about his relationship to Sifnos, writing with warmth about its unforgettable residents and the house he bought in a hilltop farm village. This is the story of how he fell in love with Greece, and how it became a haven from the complexities of his life in Western Europe and New York. It is the story of his village and of the island during the thirty-odd years he owned the house—from a time when there were barely any roads, to the arrival of the modern world with its tourists and high-speed boats and the euro. And it is the story of the end of the love affair—how the island changed and he changed, how he discovered he had outgrown Sifnos, or couldn't grow there anymore.<br/><i>The Greek House</i> is a celebration of place and an honest narrative of self-discovery. In its pages, a naïve and inexperienced young man comes into his own. Weaving himself into the life of the island, painting it year after year, he finds a place he can call home.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christian Brechneff, Tim Lovejoy
      </h2>
      
      <p class="authorDescription body article">Born in the Belgian Congo in 1950, Christian Brechneff was educated in Switzerland and the United States (St. Olaf College). In 1975 he received his master of arts degree from the Royal College of Art in London. He has exhibited in Switzerland, Spain, England, Germany, Sri Lanka, and the United States, and his paintings appear in public and private collections all over the world, including the Metropolitan Museum of Art in New York. Brechneff is also the author of <I>Homage: Encounters with the East</I>, a book of travel drawings published in 2007. He lives in Hadlyme, Connecticut.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bff507e2